import React, { useEffect, useRef } from "react";
import {
  BsFillCalendar2RangeFill,
  BsFillCalendar2DateFill,
} from "react-icons/bs";
import { GoPerson } from "react-icons/go";
import { AiFillNotification } from "react-icons/ai";
import { SiGooglemessages } from "react-icons/si";
import { FiLogOut, FiDownload } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/auth/authActions";
import { NavLink } from "react-router-dom";

function Sidebar({
  isSidebarActive,
  setIsSidebarActive,
  setMessages,
  isBadgeActive,
  newMessages,
  deferredPrompt,
  setDeferredPrompt,
}) {
  const name = useSelector((state) => state.auth?.user?.name);

  const dispatch = useDispatch();
  let menuRef = useRef();

  useEffect(() => {
    let handler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setIsSidebarActive(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [setIsSidebarActive]);

  return (
    <>
      <div
        className={`sidebar-container ${isSidebarActive ? "" : "hide"}`}
      ></div>

      <div
        ref={menuRef}
        className={`sidebar-content ${isSidebarActive ? "float-in" : ""}`}
      >
        <div className="sidebar-heading">
          <img className="sidebar-logo" src="/logo-white.svg" alt="" />
          <h1>ZabSchedule</h1>
        </div>
        <div className="sidebar-body">
          <NavLink
            to="/Home"
            onClick={() => setIsSidebarActive(false)}
            className={({ isActive }) =>
              `sidebar-link sidebar-link-container ${isActive ? "active" : ""}`
            }
          >
            <BsFillCalendar2DateFill className="sidebar-icon" size={22} />
            <p>Today's Schedule</p>
          </NavLink>
          <NavLink
            to="/Week-Schedule"
            onClick={() => setIsSidebarActive(false)}
            className={({ isActive }) =>
              `sidebar-link sidebar-link-container ${isActive ? "active" : ""}`
            }
          >
            <BsFillCalendar2RangeFill className="sidebar-icon" size={22} />
            <p>Week's Schedule</p>
          </NavLink>
          <NavLink
            to="/Notifications"
            onClick={() => setIsSidebarActive(false)}
            className={({ isActive }) =>
              `sidebar-link sidebar-link-container ${
                isBadgeActive ? "show-badge" : ""
              } ${isActive ? "active" : ""}`
            }
          >
            <AiFillNotification className="sidebar-icon" size={22} />
            <p>Announcements</p>
          </NavLink>
          <NavLink
            to="/Messages"
            onClick={() => setIsSidebarActive(false)}
            className={({ isActive }) =>
              `sidebar-link sidebar-link-container ${
                newMessages ? "show-badge" : ""
              } ${isActive ? "active" : ""}`
            }
          >
            <SiGooglemessages className="sidebar-icon" size={22} />
            <p>Messages</p>
          </NavLink>
          {deferredPrompt && (
            <div
              className="sidebar-link sidebar-link-container install-btn"
              onClick={async () => {
                deferredPrompt.prompt();
                // const { outcome } = await deferredPrompt.userChoice;
                setDeferredPrompt(null);
              }}
            >
              <FiDownload className="sidebar-icon" size={22} />
              <p>Install</p>
            </div>
          )}
          <div className="sidebar-bottom-btns-container">
            <div
              className="sidebar-link sidebar-link-container logout"
              onClick={() => {
                setIsSidebarActive(false);
                dispatch(logout());
                setMessages([]);
              }}
            >
              <FiLogOut className="sidebar-icon" size={22} />
              <p>Logout</p>
            </div>
          </div>
        </div>
        <div className="sidebar-footer">
          <div className="sidebar-icon-person">
            <GoPerson size={22} />
          </div>
          <h3>{name}</h3>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
